import Button from "components/buttons/Button"
import styled, { css } from "styled-components"
import motionTokens from "styles/motionTokens"

import type { ToastPlacement } from "./types"

const DESKTOP_OFFSET = 24
const TABLET_OFFSET = 24
const MOBILE_OFFSET = 16

const placementStyles = (placement: ToastPlacement, offset: number) => {
  switch (placement) {
    case "top-left":
      return css`
        top: ${offset}px;
        bottom: auto;
        left: ${offset}px;
        right: auto;
        align-items: flex-start;
        justify-content: flex-start;
        transform: translateX(0);
      `
    case "top-center":
      return css`
        top: ${offset}px;
        bottom: auto;
        left: 50%;
        right: auto;
        align-items: center;
        justify-content: flex-start;
        transform: translateX(-50%);
      `
    case "top-right":
      return css`
        top: ${offset}px;
        bottom: auto;
        left: auto;
        right: ${offset}px;
        align-items: flex-end;
        justify-content: flex-start;
        transform: translateX(0);
      `
    case "bottom-left":
      return css`
        top: auto;
        bottom: ${offset}px;
        left: ${offset}px;
        right: auto;
        align-items: flex-start;
        justify-content: flex-end;
        transform: translateX(0);
      `
    case "bottom-center":
      return css`
        top: auto;
        bottom: ${offset}px;
        left: 50%;
        right: auto;
        align-items: center;
        justify-content: flex-end;
        transform: translateX(-50%);
      `
    case "bottom-right":
    default:
      return css`
        top: auto;
        bottom: ${offset}px;
        left: auto;
        right: ${offset}px;
        align-items: flex-end;
        justify-content: flex-end;
        transform: translateX(0);
      `
  }
}

export const ToastViewport = styled.div<{
  $gap: number
  $desktopPlacement: ToastPlacement
  $tabletPlacement: ToastPlacement
  $mobilePlacement: ToastPlacement
}>`
  pointer-events: none;
  position: fixed;
  z-index: 11000;
  display: flex;
  flex-direction: column;
  gap: ${({ $gap }) => `${$gap}px`};
  top: auto;
  bottom: auto;
  left: auto;
  right: auto;
  justify-content: flex-end;
  align-items: flex-end;
  transform: translateX(0);

  ${({ $desktopPlacement }) =>
    placementStyles($desktopPlacement, DESKTOP_OFFSET)}

  @media (min-width: 768px) and (max-width: 1023px) {
    ${({ $tabletPlacement }) =>
      placementStyles($tabletPlacement, TABLET_OFFSET)}
  }

  @media (max-width: 767px) {
    ${({ $mobilePlacement }) =>
      placementStyles($mobilePlacement, MOBILE_OFFSET)}
  }
`

export const ToastItem = styled.div<{ $isExiting: boolean }>`
  pointer-events: auto;
  transition:
    transform ${motionTokens.duration.short}ms ${motionTokens.easing.standard},
    opacity ${motionTokens.duration.short}ms ${motionTokens.easing.standard};
  opacity: ${({ $isExiting }) => ($isExiting ? 0 : 1)};

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

export const DismissAllBar = styled.div`
  pointer-events: auto;
  display: flex;
  justify-content: flex-end;
`

export const DismissAllButton = styled(Button)`
  pointer-events: auto;
`
